import { Controller } from "stimulus"

/**
 * Manages select-all / deselect-all behavior for comment checkboxes
 * on the comment memo compose form.
 */
export default class extends Controller {
  static targets = ["selectAll", "commentCheck"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.commentCheckTargets.forEach(cb => { cb.checked = checked })
  }
}
